import { ChevronRight } from "react-feather";
import { Link } from "react-router-dom";
import { FolderClosedIcon, MonitorSmartphoneIcon } from "lucide-react";
import { styled, useTheme, Tooltip } from "@monolith-forensics/monolith-ui";
import { Evidence } from "../evidence.types";
import { CaseInfoTooltipContent, useCaseContext } from "@/Features/Cases";

const EvidenceNumber = styled.h2`
  font-size: 16px;
  font-weight: 500;

  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 10px;
  cursor: default;
`;

const BackLink = styled.h2`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  width: fit-content;
  padding: 2px 4px;
  font-weight: bold;
  font-size: 1rem;

  .link-label {
    font-weight: bold;
    font-size: 16px;

    width: fit-content;

    color: ${({ theme }) => theme.palette.text.primary};
    opacity: 0.9;

    cursor: pointer;

    &:hover {
      opacity: 1;
    }
  }
`;

const Separator = styled(ChevronRight)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

const StyledHeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
`;

export const EvidenceDetailsHeader: React.FC<{ data: Evidence }> = ({
  data,
}) => {
  const theme = useTheme();
  const caseContext = useCaseContext();

  const fromCase = caseContext?.data;
  const fromEvidence = !fromCase;

  return (
    <StyledHeaderContent>
      <Link
        to={
          fromCase
            ? `/cases/${caseContext?.data?.case_id}/evidence`
            : "/evidence"
        }
      >
        {fromEvidence && (
          <BackLink>
            <MonitorSmartphoneIcon
              color={theme.palette.primary.main}
              size={18}
            />{" "}
            <div
              className="link-label"
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 5,
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  maxWidth: 300,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                Evidence
              </span>
            </div>
          </BackLink>
        )}
        {fromCase && (
          <Tooltip
            align="start"
            side="bottom"
            delayDuration={0}
            sideOffset={5}
            hoverableContent={true}
            content={<CaseInfoTooltipContent caseData={caseContext?.data} />}
          >
            <BackLink>
              <FolderClosedIcon color={theme.palette.primary.main} size={18} />{" "}
              <div
                className="link-label"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 5,
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    maxWidth: 300,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {caseContext?.data?.case_number}
                </span>
              </div>
            </BackLink>
          </Tooltip>
        )}
      </Link>
      <Separator size={15} />
      <EvidenceNumber>
        {data?.model_name || "Unnamed Item"} ({data?.evidence_number})
      </EvidenceNumber>
    </StyledHeaderContent>
  );
};
